import React from 'react';
import './style.scss';

const WebBuilderLayout = (props) => {
  return (
    <div className="private-office br-16">
      <div className="d-flex flex-row">
        <div className="pcoded-main-container">
          <div className="pcoded-wrapper d-flex">
            <div className="pcoded-content d-flex flex-column">
              <h1 className='title text-center fs-3'>Web Builder Layout</h1>
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebBuilderLayout;